import React, { useEffect, useState } from 'react'
import { Button, Container, FormControl, Grid, InputLabel, NativeSelect, TextField, Typography } from '@mui/material';
import { useWeb3React } from '@web3-react/core';
import swal from 'sweetalert';
import { API_URL, bsccontractaddress, Bsc_Chainid, ethcontractaddress, ETH_Chainid, maticcontractaddress, Matic_Chainid } from '../../Config';
import {GenerateTokenmatic ,GenerateTokenbnb ,TokenGeneratorABI ,ABI} from "../../Config/index";
import { useCheckChain } from '../../Hooks/useCheckChain';
import Loading from "../../Components/loader/loader";
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
 

const Generatetoken = () => {
    const {account,library}=useWeb3React();
    const [tokencurrency,settokencurrency]=useState("MATIC");
    const [fee,Setfee]=useState(0);
    const {switchChain} = useCheckChain();
    const [isloading, setisloading] = useState(false);
    const history =useHistory();

    console.log(tokencurrency,"tokencurrency")

    const handlesubmit=async(e)=>{
        e.preventDefault();
        let Tokenname=e.target.tokenname.value;
        let Tokensymbol =e.target.tokensymbol.value;
        let Tokensupply =e.target.totalsupply.value;
        let Tokentype =e.target.Tokentype.value;
        let currency =e.target.currency.value;
        console.log(Tokenname,Tokensymbol,Tokensupply,Tokentype,currency,"Tokenname,Tokensymbol,Tokensupply,Tokentype,currency");
        if(library){
            if(Tokenname!="" && Tokensymbol!="" && Tokensupply!="" && Tokentype!="" && currency!=""){
                if(Tokensupply>0){

                setisloading(true);
                let contract_generator;
                let contract_address;
                const Web3= require('web3');
                const web3= new Web3(library.provider);
                if(currency=="BNB"){
                    contract_generator=GenerateTokenbnb;
                    contract_address=bsccontractaddress;
                }else if(currency=="MATIC"){
                    contract_generator=GenerateTokenmatic;
                    contract_address=maticcontractaddress;
                }else if(currency=="ETH"){
                    contract_address=ethcontractaddress;
                }
                let Tokenvalue = web3.utils.toWei(Tokensupply.toString(),"ether")
                
                const contractgenerate = new web3.eth.Contract(TokenGeneratorABI,contract_generator);
                const Contract =new web3.eth.Contract(ABI,contract_address)
                await contractgenerate.methods.getdeployfee().call().then(async(result)=>{
                    await contractgenerate.methods.deployToken(Tokenvalue,Tokenname.toString(),Tokensymbol.toString())
                    .send({from:account,value:result}).then((result)=>{
                        console.log(result.events[1].address,"result")
                        let Tokenaddress =result.events[1].address;
                        Contract.methods.addCurrenicies(Tokenaddress).send({ from: account }).then(async () => {
                            var data = new FormData();
                            data.append("token_name", Tokenname);
                            data.append("token_address", Tokenaddress);
                            data.append("currency", "MATIC");
                            data.append("address", account);
                            // data.append("Tokenbuy",tokenbuy);
                            data.append("type", "Insertdata");
            
                            await axios.post(`${API_URL}/TokenApi.php`, data, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                            }).then((result) => {
                                console.log(result,"result");
                                setisloading(false);
                                Swal.fire({
                                    icon:"success",
                                    title:"Congratulations! You successfully Generate Token",
                                    html : `<Link target="_blank" to="https://mumbai.polygonscan.com/address/${Tokenaddress}">Tokenaddress</Link>`,
                                    showCloseButton: false,
                                    showCancelButton: false,
                                    focusConfirm: false,
                                    allowOutsideClick: false,
                                    showConfirmButton: true,
                                  })
                               .then(() => {
                                    history.push('/Myitem');
                                })
                            })
            
                        }).catch(() => {
                            setisloading(false);
                            swal({
                                title: "Warning",
                                text: "Something Went Wrong",
                                icon: "error",
                                allowOutsideClick: false,
                                confirmButtonText: 'ok',
                                confirmButtonColor: '#2dbe60',
                            })
                        })
                       

                    }).catch((err)=>{
                        setisloading(false)
                        console.log(err)
                    })
                }).catch((err)=>{
                    setisloading(false)
                    console.log(err)
                })
            }else{
                swal({
                    title:"Warning",
                    icon:"error",
                    text:"please enter the total supply greater than 0",
                    allowOutsideClick: false,
                    confirmButtonText: 'ok',
                    confirmButtonColor: '#2dbe60',
                 })  
            }
               
            }else{
                swal({
                       title:"Warning",
                       icon:"error",
                       text:"Please fill all the details",
                       allowOutsideClick: false,
                       confirmButtonText: 'ok',
                       confirmButtonColor: '#2dbe60',
                    })
            }            
        }else{
            swal({
                title:"Warning",
                icon:"error",
                text:"Connect Your wallet",
                allowOutsideClick: false,
                confirmButtonText: 'ok',
                confirmButtonColor: '#2dbe60',
             })
        }
    }

    const Tokenfee=async(tokencurrency)=>{
        if(library){
            console.log(tokencurrency);
            // let contract_address;
            // if(tokencurrency=="BNB"){
            //     contract_address=GenerateTokenmatic;
            // }else if(tokencurrency=="MATIC"){
            //     contract_address=GenerateTokenmatic;
            // }else if(tokencurrency=="ETH"){
            //     contract_address=GenerateTokenmatic;
            // }
            const Web3=require('web3');
            const web3= new Web3(library.provider);
            const contract =new web3.eth.Contract(TokenGeneratorABI,GenerateTokenmatic);
            await contract.methods.getdeployfee().call().then((result)=>{
                Setfee(result/10**18);
                console.log(result);
            });
        }

    }
    useEffect(()=>{
        Tokenfee(tokencurrency);
    },[tokencurrency])

    // const checkcurrency = (e) => {
    //     let currency = e.target.value;
       
    //     if (currency == "BNB") {
    //         switchChain(Bsc_Chainid)
    //     } else if (currency == "MATIC") {
    //         switchChain(Matic_Chainid)
    //     }else if (currency == "ETH"){
    //         switchChain(ETH_Chainid)
    //     }
    //     settokencurrency(currency);

    // }


  return (
    <div>
        <Container maxWidth='lg' component='form' method='post' onSubmit={handlesubmit} >
                <Grid container spacing={2} className='fom_det'>
                    <Grid item lg={12} sm={12} md={12} xs={12}>
                        <Typography variant='h5' fontWeight='600' fontSize='25px'>Generate Token</Typography>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={12}>
                        <label className='add_n'>Token Name</label>
                        <br></br>
                        <TextField id="outlined-basic" name='tokenname' fullWidth />
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={12}>
                        <label className='add_n'>Token Symbol</label>
                        <TextField id="outlined-basic" name='tokensymbol' fullWidth />
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={12}>
                        <label className='add_n'>Total Supply</label>
                        <TextField id="outlined-basic"  name='totalsupply' fullWidth />
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                    <FormControl fullWidth className='Currency'>
                            <label className=''>Token Type</label>
                            <InputLabel variant="standard" htmlFor="uncontrolled-native">
                            </InputLabel>
                            <NativeSelect defaultValue="Fixed Token" name="Tokentype">
                                <option value="FT" >Fixed Token</option>
                            </NativeSelect>
                        </FormControl>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={12}>
                        <label className='add_n'>User Address</label>
                        <TextField id="outlined-basic"  value={account} name='useraddress' fullWidth />
                    </Grid>
                
                    <Grid item lg={6} sm={6} md={6} xs={12}>
                        <FormControl fullWidth className='Currency'>
                            <label className=''>Currency</label>
                            <InputLabel variant="standard" htmlFor="uncontrolled-native">
                            </InputLabel>
                            <NativeSelect name="currency" >
                                {/* <option value="BNB" >BNB</option> */}
                                <option value="MATIC" >MATIC</option>
                                {/* <option value="ETH" >ETH</option> */}
                            </NativeSelect>
                        </FormControl>
                    </Grid>
                  
                    <Grid item lg={6} sm={6} md={6} xs={12}>
                    <label className='add_n'>Token Generate Fee</label>
                    <Typography>{fee} MATIC</Typography>
                    </Grid>
                    
                    <Grid item lg={12} sm={12} md={12} xs={12}>
                        <Button variant='contained' type="submit">Submit</Button>
                    </Grid>
                </Grid>
            </Container>
            {isloading && <Loading props={'Transaction in process, Please wait do not refresh the page...'} />}
    </div>
  )
}

export default Generatetoken